/**
 * Formulář podepsání dokumentu.
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {submit} from "redux-form";
import { ff, form, Loader } from "@mc/mc-legacy";
import QSelectCertificateField from "../field/QSelectCertificateField";
import CustomSignApi from "../../api/gen/qsign/CustomSignApi";
import { Col, Row } from "@mc/ui-v3";
import {isWindows} from "../../utils/appUtils";
import {ModuleCode} from "@mc/react-sign";
const { FormActions, autofillReduxForm } = form;

const validate = (formData) => {
  const errors = {};

  if (!formData.certificate) {
    errors.certificate = "Není vybrán certifikát";
  }

  return errors;
};

type Props = {
  submitting: boolean;
  onClose: PropTypes.Requireable<(...args: any[]) => any>;
  viewId: number
};

type State = {
    loading: boolean;
    pluginChecking: boolean;
    pluginActual: boolean;
};

class PodepsatDokumentForm extends Component<Props, State> {
  static formName = "podepsatDokumentForm";

  constructor(props) {
      super(props);
      this.state = {
          loading: true,
          pluginChecking: false,
          pluginActual: true
      }
  }

  checkAutoSubmit = (certs) => {
      if (certs.length === 1) {
          if (certs[0].moduleCode != ModuleCode.MARBES) {
              console.log("Probíhá automatický submit formuláře, protože je právě jeden certifikát");
              this.props.dispatch(submit(PodepsatDokumentForm.formName));
          } else {
              // technické omezení prohlížečů založených na Chromiu
              console.log("Nelze provést automatický submit formuláře, protože se jedná o MC řešení");
          }
      }
  }

  render() {
    const { onClose, submitting, handleSubmit, viewId } = this.props;
    const {loading, pluginChecking, pluginActual} = this.state;
    const commons = {
      disabled: submitting,
    };
    return (
      <form.Form onSubmit={handleSubmit} horizontal>
        <Row className="px-3 my-3" noGutters>
          <Col sm={12}>
            <ff.Base
              componentClass={QSelectCertificateField}
              name={"certificate"}
              className={"no-gutters"}
              label={"Certifikát"}
              viewId={viewId}
              onLoading={(state) => {
                  console.log("onLoading", state);
                  this.setState({loading: state});
              }}
              onCertsLoaded={(certs, requestId) => {
                  console.log("onCertsLoaded", certs, requestId);
                  // const onlyHsm = certs.length === 1 && certs[0].moduleCode === 'HSM'
                  if (isWindows()) {
                      this.setState({pluginChecking: true});
                      CustomSignApi.getPluginInfo(requestId).then(info => {
                          console.info(info);
                          this.setState({pluginChecking: false, pluginActual: info.actual});
                          if (info.actual) {
                              this.checkAutoSubmit(certs);
                          }
                      }).catch(() => {
                          this.setState({pluginChecking: false});
                      });
                  } else {
                      this.checkAutoSubmit(certs);
                  }
              }}
              required
              {...commons}
            />
          </Col>
        </Row>
          {loading && <Row className="px-3 my-3">
              <Col><Loader noPadding>Načítání dostupných certifikátů...</Loader></Col>
          </Row>}
          {pluginChecking && <Row className="px-3 my-3">
              <Col><Loader noPadding>Kontrola verze rozšíření pro podepisování...</Loader></Col>
          </Row>}
          {!pluginActual && <Row className="px-3 my-3">
              <Col className="text-danger">
                  Neaktuální verze pluginu pro podepisování - aktualizace ke stažení <a href={(window as any).appConfig.serverContextPath + "/qsign/api/sign/plugin-download"}>zde</a>.
              </Col>
          </Row>}
        <FormActions onClose={onClose} disabled={submitting || loading || pluginChecking || !pluginActual} submitButton={"Podepsat"} cancelButton />
      </form.Form>
    );
  }
}

const reduxFormObj = autofillReduxForm({
  form: PodepsatDokumentForm.formName,
  validate: validate,
  autofillContext: "sign.form",
})(PodepsatDokumentForm);
export default connect()(reduxFormObj);
